import { render, staticRenderFns } from "./DepartmentMemberListItem.vue?vue&type=template&id=56acc444&scoped=true&"
import script from "./DepartmentMemberListItem.vue?vue&type=script&lang=js&"
export * from "./DepartmentMemberListItem.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentMemberListItem.vue?vue&type=style&index=0&id=56acc444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56acc444",
  null
  
)

export default component.exports